import {useCallback} from 'react'
import {NavigateOptions, useNavigate} from 'react-router-dom'
import {useI18n} from './I18nContext'
import {withLocalePath} from './localePaths'

export function useLocalizedNavigate() {
  const navigate = useNavigate()
  const {locale} = useI18n()

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to)
        return
      }
      navigate(withLocalePath(locale, to), options)
    },
    [navigate, locale],
  )
}
